/**
 * Gift Card Product Template JavaScript
 * Handles language-based variant selection and image updates
 */

(function giftcardLanguageInit() {
  /**
   * Initialize gift card functionality
   */
  function initGiftCard() {
    const languageSwatchContainer = document.querySelector('.js-swatch-Langue');

    if (!languageSwatchContainer) {
      return;
    }

    const currentLocale = window.giftcardCurrentLocale || '';
    const languageInputs = languageSwatchContainer.querySelectorAll('input[type="radio"]');
    const variants = window.giftcardVariants || [];

    /**
     * Update the gift card image based on selected language
     * @param {string} language - The language code (e.g., 'en', 'fr')
     */
    function updateImageForLanguage(language) {
      const localeVariant = variants.find((v) => v.option2 === language);
      const giftCardImage = document.querySelector('.product-gallery__wrapper--giftcard img');

      if (localeVariant && localeVariant.featured_image && giftCardImage) {
        // Update image source with 1000x size
        giftCardImage.src = localeVariant.featured_image.src.replace(/(\.\w{3,4})$/, '_1000x$1');
        giftCardImage.alt = localeVariant.title || localeVariant.featured_image.alt;
        giftCardImage.setAttribute('data-variant-id', localeVariant.id);
      }
    }

    // Add change event listeners to language radio buttons
    languageInputs.forEach((input) => {
      // Pre-select the current locale
      if (input.value === currentLocale) {
        input.checked = true;
      }

      // Listen for language changes
      input.addEventListener('change', function handleLanguageChange() {
        if (this.checked) {
          updateImageForLanguage(this.value);
        }
      });
    });

    // Initial image update based on current locale
    updateImageForLanguage(currentLocale);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftCard);
  } else {
    initGiftCard();
  }
})();
